import { DrmKeySystemAvailability, DrmRobustness, DrmType, HdcpStatus, QualityCategory } from '@cbsinteractive/avia-js';
import { AbstractResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/abstract/AbstractResourceConfigBuilder';
export class AbstractDesktopResourceConfigBuilder extends AbstractResourceConfigBuilder {
    constructor(argument) {
        super({
            name: 'AbstractDesktopResourceConfigBuilder',
            ...argument
        });
    }
    getResult() {
        return new Promise((resolve, reject) => {
            const resource = window.avia.createResourceConfig();
            this?.logger?.log('getResult', 'created instance of ResourceConfigurationInterface using avia:', resource);
            const promiseArray = [
                () => this.tag.model.siteUtilities.getSiteSessionData(this.name),
                () => this.setAdaptiveBitrateSettings(resource),
                () => this.setContextMetadata(resource),
                () => this.setOverrides(resource)
            ];
            this.utils.Function.runPromiseArray(promiseArray).then(() => {
                resolve({ msg: 'Resource config', resource: resource });
            });
        });
    }
    #hdcpBitrateProcessor = (resource) => {
        return new Promise((resolve, reject) => {
            const drmStatus = window?.SmartTag?.deviceCapabilities?.drm;
            const getKeySystemStatus = (keySystem) => {
                const filteredKeySystemStatus = drmStatus.keySystemStatus.filter((obj) => {
                    return (obj?.keySystem === keySystem
                        &&
                            obj?.availability === DrmKeySystemAvailability.DETECTED);
                });
                return ((!this.utils.Type.isEmpty(filteredKeySystemStatus)
                    &&
                        this.utils.Type.isArray(filteredKeySystemStatus))
                    ?
                        filteredKeySystemStatus[0]
                    :
                        undefined);
            };
            const getHdcpStatus = (version) => {
                const hdcpStatus = drmStatus.hdcpStatus.filter((obj) => {
                    return (parseFloat(obj?.version) >= version
                        &&
                            obj?.status === HdcpStatus.USABLE);
                });
                return ((!this.utils.Type.isEmpty(hdcpStatus)
                    &&
                        this.utils.Type.isArray(hdcpStatus))
                    ?
                        hdcpStatus[0]
                    :
                        undefined);
            };
            const setMaxCategory = (resource, maxCategory = QualityCategory.SD) => {
                resource.playback = this.utils.DeepMerge.deepmerge(resource.playback, {
                    abr: {
                        maxCategory: maxCategory
                    }
                });
                return resource;
            };
            if (this.utils.Type.isEmpty(this?.params?.CONTENT?.drm?.widevine?.url) === false) {
                const keySystemStatus = getKeySystemStatus(DrmType.WIDEVINE);
                const hdcpStatus = getHdcpStatus(2);
                const hdcpVersion = parseFloat(hdcpStatus?.version);
                this?.logger?.log('hdcpBitrateProcessor:', 'keySystemStatus:', keySystemStatus, 'hdcpStatus:', hdcpStatus, 'hdcpVersion:', hdcpVersion);
                switch (keySystemStatus?.robustness) {
                    case DrmRobustness.SW_SECURE_CRYPTO:
                    case DrmRobustness.SW_SECURE_DECODE:
                    case DrmRobustness.UNKNOWN:
                    case undefined:
                        resource = setMaxCategory(resource, QualityCategory.SD);
                        break;
                }
            }
            this?.logger?.log('hdcpBitrateProcessor:', 'maxCategory:', resource?.playback?.abr?.maxCategory);
            resolve(resource);
        });
    };
    setAdaptiveBitrateSettings(resource) {
        return new Promise((resolve, reject) => {
            resource.playback.abr.capQualityToScreenSize = !this.capabilities.isDesktop;
            this?.logger?.log('setAdaptiveBitrateSettings', 'set resource.playback.abr.capQualityToScreenSize:', resource.playback.abr.capQualityToScreenSize);
            const promiseArray = [
                () => this.#hdcpBitrateProcessor(resource),
                () => this.setStartBitrate(resource)
            ];
            this.utils.Function.runPromiseArray(promiseArray).then(() => {
                resolve(resource);
            });
        });
    }
    setContextMetadata(resource) {
        const setDeviceFramework = (resource) => {
            resource.metadata.deviceCategory = 'WEB';
            resource.metadata.frameworkName = 'SmartTag';
            resource.metadata.frameworkVersion = window?.PlayerServicesProjectInfo?.release_version;
            return resource;
        };
        return new Promise((resolve, reject) => {
            if (resource.metadata === undefined)
                resource.metadata = {};
            if (!this.utils.Type.isEmpty(this.params?.CONTEXT?.metadata)
                &&
                    this.utils.Type.isObject(this.params?.CONTEXT?.metadata)) {
                Object.keys(this.params?.CONTEXT?.metadata).forEach((key) => {
                    resource.metadata[key] = this.params.CONTEXT.metadata[key];
                });
            }
            resource = setDeviceFramework(resource);
            this?.logger?.log('setContextMetadata', 'resolving resource...', resource);
            resolve(resource);
        });
    }
}
